import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TenantPage } from './tenant.page';
import { TenantDesktopPage } from './desktop/tenant.desktop.page';
import { TenantMobilePage } from './mobile/tenant.mobile.page';
import { TranslationModule } from '@app/app-translation.module';
import { PipesModule } from '@shared-pipes/pipes.module';
import { FormInputModule, FormLabelModule, FormTextareaModule } from '@beego/ngx-form-components';
import { FormFullAddressModule } from '@internal/gui/structural-components/form-components/form-full-address-component/form-full-address.component.module';
import { PageHeaderComponentModule } from '@shared-components/page-header-component/page-header.component.module';
import { SegmentDesktopModule } from '@beego/ngx-segment';
import { TableDesktopModule } from '@beego/ngx-table';
import { AppModule } from '@app/app.module';
import { StateManager } from '@shared-managers/state.manager';
import { TranslateService } from '@ngx-translate/core';
import { EditorComponentModule } from '@internal/gui/structural-components/editor-component/editor.component.module';
import { DirectivesModule } from '@shared-directives/directives.module';
import { PermissionGroupsComponentModule } from '@internal-components/permission-group-components/permission-groups-component/permission-groups.component.module';
import { MobileBlockerComponentModule } from '@internal/gui/structural-components/mobile-blocker-component/mobile-blocker-component.module';
import { SearchOrganizerComponentModule } from '@internal/gui/structural-components/search-organizer-component/search-organizer.component.module';
import { OrganizerNamePipe } from '@shared-pipes/organizer-name.pipe';
import { TooltipModule } from '@make-lynxwork/ng2-tooltip-directive';
import { UiTDatabaseLabelComponentModule } from '@internal-components/administration-components/uit-database-label-components/uit-database-label-component/uit-database-label.component.module';
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: TenantPage,
			},
		]),
		TableDesktopModule.forRoot(AppModule.injector.get(StateManager), AppModule.injector.get(TranslateService)),
		TranslationModule,
		PageHeaderComponentModule,
		PipesModule,
		DirectivesModule,
		FormInputModule,
		FormTextareaModule,
		FormFullAddressModule,
		FormLabelModule,
		SegmentDesktopModule,
		EditorComponentModule,
		PermissionGroupsComponentModule,
		MobileBlockerComponentModule,
		SearchOrganizerComponentModule,
		TooltipModule,
		UiTDatabaseLabelComponentModule,
	],
	declarations: [TenantPage, TenantDesktopPage, TenantMobilePage],
	providers: [OrganizerNamePipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TenantPageModule {}
